import React, { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Login from './pages/Login';
import Home from './pages/Home';
import RequestForApproval from './pages/RequestForApproval';
import { LoadingProvider } from './Utils/LoadingContext';
import LoadingSpinner from './components/LoadingSpinner';
import { ToastContainer } from 'react-toastify';
import Dashboard from './pages/Dashboard';
import EmployeeMaster from './pages/EmployeeMaster';
import EmployeeUpdate from './pages/EmployeeUpdate';
import RouteGuard from './components/RouteGuard';
import LeftSidebar from './components/LeftSidebar';
import EmployeeSave from './pages/EmployeeSave';
import AttendanceUpload from './pages/AttendanceUpload';
import MenuMaster from './pages/MenuMaster';
import './App.css';
import TPLogin from './pages/TPLogin';
import EmployeeUpload from './pages/EmployeeUpload';
import ClmsEmployee from './pages/ClmsEmployee';
import ClmsEmployeeUpdate from './pages/ClmsEmployeeUpdate';
import PunchCalendar from './pages/PunchCalendar';
import EmployeeDetails from './pages/EmployeeDetails';
import ShiftAllocation from './pages/ShiftAllocation';
import HolidayUploadForm from './pages/HolidayUpload';
import HolidayCalendar from './pages/HolidayCalendar';
import { isTokenValid } from './Utils/auth';
import useIsMobile from './useIsMobile';
import WeekOffAllocation from './pages/WeekOffAllocation';
import AttendanceReport from './pages/AttendanceReport';
import EmployeeListReport from './pages/EmployeeListReport';
import EmployeeDOLReports from './pages/EmployeeDOLReports';
import PlantRights from './pages/PlantRights';
import MasterData from './pages/MasterData';
import AttendancePivotReport from './pages/AttendancePivotReport';
import AttendancePunchReport from './pages/AttendancePunchReport';
import MonthlyOT from './pages/MonthlyOT';
import CompanyRights from './pages/CompanyRights';
import VendorRights from './pages/VendorRights';
import PunchPivotINOUT from './pages/PunchPivotINOUT';
import ExecuteProcedurePage from './pages/ExecuteProcedurePage';
import DailyPunch from './pages/DailyPunch';
import EmailRights from './pages/EmailRights';
import PlantWisePie from './pages/PlantWiseAttendance';
import AttendanceMonthlyPDF from './pages/AttendanceMonthlyPDF';
import PlanVSActual from './pages/PlanVSActual';
import PlanVSActualReport from './pages/PlanVSActualReport';
import PunchUpload from './pages/PunchUpload';
import InActiveUpload from './pages/InActiveUpload';
import AttendanceSync from './pages/AttendanceSync';
import AttendanceRights from './pages/AttendanceRights';
import ShiftMaster from './pages/ShiftMaster';
import AttendanceDashboard from './pages/AttendanceDashboard';
import AttendanceDetails from './pages/AttendanceDetails';
import LeaveApply from './pages/LeaveApply';
import LeaveStatus from './pages/LeaveStatus';
import LeaveApproval from './pages/LeaveApproval';
import LeaveMaster from './pages/LeaveMaster';
import AttendanceRegularization from './pages/AttendanceRegularization';
import OnDutyApply from './pages/OnDutyApply';
import PayRollGenerator from './pages/PayRollGenerator';
import DepartmentRights from './pages/DepartmentRights';
import LeaveUpload from './pages/LeaveUpload';
import LeaveBalanceUpload from './pages/LeaveBalanceUpload';
import LeaveBalanceView from './pages/LeaveBalanceView';
import EmployeeAttendance from './pages/EmployeeAttendance';
import EmployeeProfile from './pages/EmployeeProfile';
import DepartmentWisePunch from './pages/DepartmentWisePunch';
import EmployeeFloorWiseAllocation from './pages/EmployeeFloorWiseAllocation';
import EmployeeUserLogin from './pages/EmployeeUserLogin';

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile(); // call the hook
  const isLoginPage = location.pathname === '/';

  useEffect(() => {
    const interval = setInterval(() => {
      const loginTime = localStorage.getItem("loginTime");
      if (loginTime && new Date().getTime() - loginTime > 30 * 60 * 1000) {
        localStorage.clear();
        navigate('/', { replace: true }); // Redirect to login
      }
    }, 60000); // check every minute
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token || !isTokenValid(token)) {
      localStorage.clear();
      navigate('/', { replace: true }); // Redirect to login
    }
  }, [location.pathname, navigate]);
  return (
    <LoadingProvider>
      <ToastContainer position="bottom-right" autoClose={5000} />
      <LoadingSpinner />

      {/* Show Header only if not on Login page */}
      {!isLoginPage && <Header />}

      {/* Main layout */}
      {isLoginPage ? (
        <Routes>
          <Route path="/" element={<Login />} />
        </Routes>
      ) : (
        <div className="main-layout">

          {!isMobile && (
            <div className="left-sidebar" style={{ marginBottom: 0 }}>
              <LeftSidebar />
            </div>
          )}

          <div className="main-content">
            <Routes>
              {/* <Route path="/home" element={<Home />} /> */}
              <Route path="/home" element={<AttendanceDashboard />} />
              <Route path="/PlantDashboard" element={<Home />} />
              <Route path="/HolidayCalendar" element={<RouteGuard><HolidayCalendar /></RouteGuard>} />

              {/* <Route path="/dashboard" element={<RouteGuard><Dashboard /></RouteGuard>} /> */}
              <Route path="/EmployeeDetails" element={<RouteGuard><EmployeeDetails /></RouteGuard>} />
              <Route path="/AttendanceUpdate" element={<RouteGuard><PunchCalendar /></RouteGuard>} />
              <Route path="/AttendanceReports" element={<RouteGuard><AttendanceReport /></RouteGuard>} />
              <Route path="/EmployeeListReports" element={<RouteGuard><EmployeeListReport /></RouteGuard>} />
              <Route path="/EmployeeDOLReports" element={<RouteGuard><EmployeeDOLReports /></RouteGuard>} />
              <Route path="/ShiftAllocation" element={<RouteGuard><ShiftAllocation /></RouteGuard>} />
              <Route path="/WeekOffAllocation" element={<RouteGuard><WeekOffAllocation /></RouteGuard>} />
              <Route path="/create-request" element={<RouteGuard><RequestForApproval /></RouteGuard>} />
              <Route path="/EmployeeMaster" element={<RouteGuard><ClmsEmployee /></RouteGuard>} />
              {/* <Route path="/EmployeeMaster" element={<RouteGuard><EmployeeSave /></RouteGuard>} /> */}
              {/* <Route path="/EmployeeUpdate" element={<RouteGuard><EmployeeUpdate /></RouteGuard>} /> */}
              <Route path="/EmployeeUpdate" element={<RouteGuard><ClmsEmployeeUpdate /></RouteGuard>} />
              <Route path="/HolidayUpload" element={<RouteGuard><HolidayUploadForm /></RouteGuard>} />
              <Route path="/AttendanceMaster" element={<RouteGuard><AttendanceUpload /></RouteGuard>} />
              <Route path="/MenuMaster" element={<RouteGuard><MenuMaster /></RouteGuard>} />
              <Route path="/TPRights" element={<RouteGuard><TPLogin /></RouteGuard>} />
              <Route path="/PlantRights" element={<RouteGuard><PlantRights /></RouteGuard>} />
              <Route path="/AttendancePunch" element={<RouteGuard><AttendancePunchReport /></RouteGuard>} />
              <Route path="/EmployeeUpload" element={<RouteGuard><EmployeeUpload /></RouteGuard>} />
              <Route path="/MasterData" element={<RouteGuard><MasterData /></RouteGuard>} />
              <Route path="/AttendanceDayWise" element={<RouteGuard><AttendancePivotReport /></RouteGuard>} />
              <Route path="/OTReport" element={<RouteGuard><MonthlyOT /></RouteGuard>} />
              <Route path="/PunchPivotINOut" element={<RouteGuard><PunchPivotINOUT /></RouteGuard>} />
              <Route path="/CompanyRights" element={<RouteGuard><CompanyRights /></RouteGuard>} />
              <Route path="/RefreshData" element={<RouteGuard><ExecuteProcedurePage /></RouteGuard>} />
              <Route path="/VendorRights" element={<RouteGuard><VendorRights /></RouteGuard>} />
              <Route path="/DailyPunch" element={<RouteGuard><DailyPunch /></RouteGuard>} />
              <Route path="/EmailRights" element={<RouteGuard><EmailRights /></RouteGuard>} />
              <Route path="/PlantWisePie" element={<RouteGuard><PlantWisePie /></RouteGuard>} />
              <Route path="/AttendancePDF" element={<RouteGuard><AttendanceMonthlyPDF /></RouteGuard>} />
              <Route path="/SetPlan" element={<RouteGuard><PlanVSActual /></RouteGuard>} />
              <Route path="/GetPlanReport" element={<RouteGuard><PlanVSActualReport /></RouteGuard>} />
              <Route path="/PunchUpload" element={<RouteGuard><PunchUpload /></RouteGuard>} />
              <Route path="/InActiveUpload" element={<RouteGuard><InActiveUpload /></RouteGuard>} />
              <Route path="/KentSync" element={<RouteGuard><AttendanceSync /></RouteGuard>} />
              <Route path="/AttendanceRights" element={<RouteGuard><AttendanceRights /></RouteGuard>} />
              <Route path="/ShiftMaster" element={<RouteGuard><ShiftMaster /></RouteGuard>} />
              {/* <Route path="/AttendanceDetails" element={<RouteGuard><AttendanceDetails /></RouteGuard>} /> */}
              <Route path="/AttendanceRegularization" element={<RouteGuard><AttendanceRegularization /></RouteGuard>} />
              <Route path="/LeaveApply" element={<RouteGuard><LeaveApply /></RouteGuard>} />
              <Route path="/LeaveStatus" element={<RouteGuard><LeaveStatus /></RouteGuard>} />
              <Route path="/LeaveApprove" element={<RouteGuard><LeaveApproval /></RouteGuard>} />
              <Route path="/LeaveMaster" element={<RouteGuard><LeaveMaster /></RouteGuard>} />
              <Route path="/OnDutyApply" element={<RouteGuard><OnDutyApply /></RouteGuard>} />
              <Route path="/PayRollGenerator" element={<RouteGuard><PayRollGenerator /></RouteGuard>} />
              <Route path="/DepartmentRights" element={<RouteGuard><DepartmentRights /></RouteGuard>} />
              <Route path="/LeaveUpload" element={<RouteGuard><LeaveUpload /></RouteGuard>} />
              <Route path="/LeaveBalanceUpload" element={<RouteGuard><LeaveBalanceUpload /></RouteGuard>}/>
              <Route path="/LeaveBalanceView" element={<RouteGuard><LeaveBalanceView /></RouteGuard>}/>
              <Route path="/EmployeeAttendance" element={<RouteGuard><EmployeeAttendance /></RouteGuard>}/>
              <Route path="/EmployeeProfile" element={<RouteGuard><EmployeeProfile /></RouteGuard>}/>
              <Route path="/DepartmentWisePunch" element={<RouteGuard><DepartmentWisePunch /></RouteGuard>}/>
              <Route path="/EmployeeFloorWise" element={<RouteGuard><EmployeeFloorWiseAllocation /></RouteGuard>}/>
              <Route path="/EmployeePassword" element={<RouteGuard><EmployeeUserLogin /></RouteGuard>}/>
            </Routes>
          </div>
        </div>
      )}

      {/* Show Footer only if not on Login page */}
      {!isLoginPage && <Footer />}
    </LoadingProvider>
  );
}

export default App;
